export const ROOT = '/Survey';
export const ROOT2 = '/BackgroundCheck';
export const GET_SURVEY_BY_ID = `${ROOT}/getsurvey`;
export const GET_SURVEY_RESPONSE_BY_ID = `${ROOT}/getsurveyresponse`;
export const SUBMIT_SURVEY_RESPONSE = `${ROOT}/submitsurveyresponse`;
export const GET_COMPANY_APPLICANT = `${ROOT}/getcompanyandapplicant`;
export const GET_BC_STATUS = `${ROOT2}/getbackgroundcheck`;
export const GET_EXPIRY = `${ROOT}/getexpiry`;
